import { useTranslation } from 'react-i18next';

function About() {
  const { t } = useTranslation();

  const styles = {
    container: {
      backgroundColor: '#ffffff',
      minHeight: '100vh',
      padding: '80px 20px',
      fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
    },
    maxWidth: {
      maxWidth: '1200px',
      margin: '0 auto'
    },
    header: {
      textAlign: 'center',
      marginBottom: '80px'
    },
    mainTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      color: '#333',
      marginBottom: '20px',
      lineHeight: '1.2'
    },
    subtitle: {
      fontSize: '1.3rem',
      color: '#666',
      lineHeight: '1.6',
      maxWidth: '800px',
      margin: '0 auto'
    },
    highlight: {
      color: '#dc2626',
      fontWeight: '600'
    },
    content: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '60px',
      marginBottom: '80px'
    },
    section: {
      textAlign: 'center'
    },
    sectionTitle: {
      fontSize: '2.2rem',
      fontWeight: '600',
      color: '#333',
      marginBottom: '30px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px'
    },
    sectionContent: {
      fontSize: '1.1rem',
      color: '#555',
      lineHeight: '1.8',
      maxWidth: '900px',
      margin: '0 auto'
    },
    companyName: {
      color: '#dc2626',
      fontWeight: '600'
    },
    statsContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '40px',
      marginTop: '60px'
    },
    statItem: {
      textAlign: 'center',
      padding: '40px 20px'
    },
    statNumber: {
      fontSize: '4rem',
      fontWeight: '700',
      color: '#dc2626',
      marginBottom: '10px',
      display: 'block'
    },
    statLabel: {
      fontSize: '1.2rem',
      color: '#333',
      fontWeight: '500',
      lineHeight: '1.4'
    },
    divider: {
      width: '100px',
      height: '4px',
      backgroundColor: '#dc2626',
      margin: '40px auto',
      borderRadius: '2px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.maxWidth}>
        {/* Header Section */}
        <div style={styles.header}>
          <h1 style={styles.mainTitle}>
            {t('home.about.title')}
          </h1>
          <p style={styles.subtitle}>
            {t('home.about.subtitlePart1')}
            <span style={styles.highlight}>{t('home.about.years')}</span>
            {t('home.about.subtitlePart2')}
          </p>
        </div>

        <div style={styles.divider}></div>

        {/* Main Content */}
        <div style={styles.content}>
          <div style={styles.section}>
            <h2 style={styles.sectionTitle}>
              {t('home.about.whoTitle')}
            </h2>
            <div style={styles.sectionContent}>
              <p>
                <span style={styles.companyName}>{t('home.about.companyName')}</span>{' '}
                {t('home.about.paragraph1')}
              </p>
              <br />
              <p>
                {t('home.about.paragraph2Pre')}
                <span style={styles.companyName}>{t('home.about.subsidiaryName')}</span>
                {t('home.about.paragraph2Post')}
              </p>
            </div>
          </div>
        </div>

        <div style={styles.divider}></div>

        {/* Stats Section */}
        <div style={styles.statsContainer}>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>50+</span>
            <div style={styles.statLabel}>
              {t('home.about.stat1Label')}
            </div>
          </div>
          <div style={styles.statItem}>
            <span style={styles.statNumber}>CPA</span>
            <div style={styles.statLabel}>
              {t('home.about.stat2Label')}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
